document.addEventListener('DOMContentLoaded', function() {
  // Initialize all countdown timers on the page
  const countdownBanners = document.querySelectorAll('.countdown-banner');
  
  countdownBanners.forEach(function(banner) {
    initializeCountdown(banner);
  });
  
  // Function to parse date in US Eastern Timezone
  function parseDateInUSTimezone(dateStr, timeStr) {
    // Parse the date components
    const [year, month, day] = dateStr.split('-').map(Number);
    const [hours, minutes] = timeStr.split(':').map(Number);
    
    // Create a date string that represents the target time in US Eastern
    // We need to find the UTC time that equals this US Eastern time
    
    // Use iterative approach to find the correct UTC time
    // Start with an estimate: US Eastern is typically UTC-5 (EST) or UTC-4 (EDT)
    let targetUTC = Date.UTC(year, month - 1, day, hours + 5, minutes, 0); // Start with EST offset
    
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
    
    // Iterate to find the exact UTC time
    for (let i = 0; i < 10; i++) {
      const checkDate = new Date(targetUTC);
      const parts = formatter.formatToParts(checkDate);
      const checkYear = parseInt(parts.find(p => p.type === 'year').value);
      const checkMonth = parseInt(parts.find(p => p.type === 'month').value);
      const checkDay = parseInt(parts.find(p => p.type === 'day').value);
      const checkHour = parseInt(parts.find(p => p.type === 'hour').value);
      const checkMinute = parseInt(parts.find(p => p.type === 'minute').value);
      
      // Check if we've found the correct time
      if (checkYear === year && checkMonth === month && checkDay === day && 
          checkHour === hours && checkMinute === minutes) {
        break; // Found it!
      }
      
      // Calculate the difference
      // Create dates in local time to compare
      const checkLocal = new Date(checkYear, checkMonth - 1, checkDay, checkHour, checkMinute, 0);
      const targetLocal = new Date(year, month - 1, day, hours, minutes, 0);
      const diffMs = targetLocal.getTime() - checkLocal.getTime();
      
      // Adjust UTC time
      targetUTC += diffMs;
      
      // Prevent infinite loop if difference is too small
      if (Math.abs(diffMs) < 1000) break;
    }
    
    return new Date(targetUTC);
  }
  
  function initializeCountdown(bannerElement) {
    const timerElement = bannerElement.querySelector('.countdown-banner__timer');
    if (!timerElement) return;
    
    // Check if using custom date from settings
    const useCustomDate = bannerElement.getAttribute('data-use-custom-date') === 'true';
    const targetDateStr = bannerElement.getAttribute('data-target-date');
    const targetTimeStr = bannerElement.getAttribute('data-target-time') || '23:59';
    
    let targetDate;
    
    if (useCustomDate && targetDateStr) {
      // Use custom date from settings
      try {
        // Parse date and time in US Eastern Time (America/New_York)
        targetDate = parseDateInUSTimezone(targetDateStr, targetTimeStr);
        
        // Validate date
        if (isNaN(targetDate.getTime())) {
          console.warn('Invalid date format, falling back to session-based countdown');
          targetDate = getOrCreateTargetDate('countdown_banner_end_time');
        }
      } catch (e) {
        console.warn('Error parsing date, falling back to session-based countdown', e);
        targetDate = getOrCreateTargetDate('countdown_banner_end_time');
      }
    } else {
      // Use session-based countdown (3 hours from first visit)
      const sessionKey = 'countdown_banner_end_time';
      targetDate = getOrCreateTargetDate(sessionKey);
    }
    
    // Get timer elements
    const daysElement = timerElement.querySelector('#countdown-days');
    const hoursElement = timerElement.querySelector('#countdown-hours');
    const minutesElement = timerElement.querySelector('#countdown-minutes');
    const secondsElement = timerElement.querySelector('#countdown-seconds');
    
    if (!hoursElement || !minutesElement || !secondsElement) {
      return;
    }
    
    // Update countdown every second
    const countdownInterval = setInterval(function() {
      updateCountdown(
        targetDate, 
        daysElement, 
        hoursElement, 
        minutesElement, 
        secondsElement, 
        bannerElement, 
        countdownInterval
      );
    }, 1000);
    
    // Initial update
    updateCountdown(
      targetDate, 
      daysElement, 
      hoursElement, 
      minutesElement, 
      secondsElement, 
      bannerElement, 
      countdownInterval
    );
  }
  
  function getOrCreateTargetDate(sessionKey) {
    // Check if we already have a target date in sessionStorage
    const savedEndTime = sessionStorage.getItem(sessionKey);
    
    if (savedEndTime) {
      // Use existing target date
      return new Date(parseInt(savedEndTime));
    } else {
      // Create new target date (3 hours from now)
      const now = new Date();
      const targetDate = new Date(now.getTime() + (3 * 60 * 60 * 1000)); // 3 hours in milliseconds
      
      // Save to sessionStorage
      sessionStorage.setItem(sessionKey, targetDate.getTime().toString());
      
      return targetDate;
    }
  }
  
  function updateCountdown(targetDate, daysElement, hoursElement, minutesElement, secondsElement, bannerElement, interval) {
    const now = new Date().getTime();
    const distance = targetDate.getTime() - now;
    
    // If countdown is finished
    if (distance < 0) {
      clearInterval(interval);
      if (daysElement) daysElement.textContent = '00';
      hoursElement.textContent = '00';
      minutesElement.textContent = '00';
      secondsElement.textContent = '00';
      
      // Add expired class to banner
      bannerElement.classList.add('expired');
      
      // Hide timer and CTA, show expired text
      const timerContainer = bannerElement.querySelector('[data-timer-container]');
      const bottomRow = bannerElement.querySelector('.countdown-banner__bottom-row');
      const titleElement = bannerElement.querySelector('[data-title-element]');
      const expiredTextElement = bannerElement.querySelector('[data-expired-text]');
      
      if (timerContainer) {
        timerContainer.style.display = 'none';
      }
      if (bottomRow) {
        bottomRow.style.display = 'none';
      }
      if (titleElement) {
        titleElement.style.display = 'none';
      }
      if (expiredTextElement) {
        expiredTextElement.style.display = 'block';
      } else if (titleElement) {
        // If no expired text is set, show the title
        titleElement.style.display = 'block';
      }
      
      // Center the content
      const contentElement = bannerElement.querySelector('.countdown-banner__content');
      if (contentElement) {
        contentElement.style.justifyContent = 'center';
      }
      
      return;
    }
    
    // Calculate time units
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    // Update display with animation
    if (daysElement) {
      updateTimeDisplay(daysElement, days, 2);
    }
    updateTimeDisplay(hoursElement, hours);
    updateTimeDisplay(minutesElement, minutes);
    updateTimeDisplay(secondsElement, seconds);
  }
  
  function updateTimeDisplay(element, value, minDigits = 2) {
    const formattedValue = value.toString().padStart(minDigits, '0');
    
    if (element.textContent !== formattedValue) {
      // Add updating animation
      element.classList.add('updating');
      
      // Update value
      element.textContent = formattedValue;
      
      // Remove animation class after animation completes
      setTimeout(function() {
        element.classList.remove('updating');
      }, 200);
    }
  }
  
  // Optional: Add functionality to reset countdown
  window.countdownBanner = {
    reset: function() {
      // Clear sessionStorage and reload page to restart countdown
      sessionStorage.removeItem('countdown_banner_end_time');
      location.reload();
    },
    getTimeRemaining: function() {
      // Get remaining time in the current session
      const savedEndTime = sessionStorage.getItem('countdown_banner_end_time');
      if (savedEndTime) {
        const now = new Date().getTime();
        const distance = parseInt(savedEndTime) - now;
        return Math.max(0, distance);
      }
      return 0;
    }
  };
});
